import apiClient from './client';

export interface PartnerGuestGrant {
  id: string;
  ownerCompanyId: string;
  partnerCompanyId: string;
  userId: string;
  status: 'PENDING' | 'ACTIVE' | 'REVOKED';
  invitedAt: string;
  acceptedAt?: string;
  revokedAt?: string;
  // Enriched fields — populated by the list operation
  userEmail?: string;
  userFullName?: string;
  partnerCompanyName?: string;
}

export const partnerGuestsApi = {
  async list(
    companyId: string
  ): Promise<{ success: true; data: PartnerGuestGrant[] } | { success: false; error: string }> {
    try {
      const r = await apiClient.get<{ success: boolean; data: { grants: PartnerGuestGrant[] } }>(
        `/api/admin/${companyId}/partner-guests`
      );
      return { success: true as const, data: r.data.data.grants };
    } catch (e: any) {
      return {
        success: false as const,
        error: e.response?.data?.error ?? 'Failed to load partner guests',
      };
    }
  },

  async invite(
    companyId: string,
    body: { partnerCompanyId: string; email: string; expiresInDays?: number }
  ): Promise<
    | { success: true; data: { invitation: unknown; grantId: string } }
    | { success: false; error: string; code?: string }
  > {
    try {
      const r = await apiClient.post(
        `/api/admin/${companyId}/partner-guests/invitations`,
        body
      );
      return { success: true as const, data: r.data.data };
    } catch (e: any) {
      return {
        success: false as const,
        error: e.response?.data?.error ?? 'Failed to invite',
        code: e.response?.data?.code,
      };
    }
  },

  async revoke(
    companyId: string,
    grantId: string,
    reason?: string
  ): Promise<{ success: true; data: { id: string } } | { success: false; error: string }> {
    try {
      const r = await apiClient.delete(
        `/api/admin/${companyId}/partner-guests/${grantId}`,
        { data: { reason } }
      );
      return { success: true as const, data: r.data.data };
    } catch (e: any) {
      return {
        success: false as const,
        error: e.response?.data?.error ?? 'Failed to revoke',
      };
    }
  },

  async accept(
    token: string,
    password?: string,
    fullName?: string
  ): Promise<
    | { success: true; data: { userId: string; ownerCompanyId: string; partnerCompanyId: string } }
    | { success: false; error: string; code?: string }
  > {
    try {
      const r = await apiClient.post(`/api/admin/partner-guest-invitations/accept`, {
        token,
        password,
        fullName,
      });
      return { success: true as const, data: r.data.data };
    } catch (e: any) {
      return {
        success: false as const,
        error: e.response?.data?.error ?? 'Failed to accept',
        code: e.response?.data?.code,
      };
    }
  },
};
